$component-class: 'dh-heading';

// ── Typography scale from pdfFiller Figma styleguide ────────────────────────
// Maps: variant → (mobile, desktop) for font-size, line-height, font-weight, letter-spacing
// Desktop breakpoint: dh-md (1024px)

$heading-config: (
  1: (
    font-size-sm: map-get($font-sizes, 5xl),        // 40px
    font-size-lg: map-get($font-sizes, 7xl),        // 56px
    line-height-sm: map-get($line-heights, 2xl),    // 120%
    line-height-lg: map-get($line-heights, 2xl),    // 120%
    font-weight-sm: map-get($font-weights, extra-bold), // 800
    font-weight-lg: map-get($font-weights, extra-bold), // 800
    letter-spacing-sm: -0.01em,
    letter-spacing-lg: -0.02em,
  ),
  2: (
    font-size-sm: map-get($font-sizes, 4xl),        // 36px
    font-size-lg: map-get($font-sizes, 6xl),        // 48px
    line-height-sm: map-get($line-heights, 2xl),    // 120%
    line-height-lg: map-get($line-heights, 2xl),    // 120%
    font-weight-sm: map-get($font-weights, extra-bold),
    font-weight-lg: map-get($font-weights, extra-bold),
    letter-spacing-sm: -0.01em,
    letter-spacing-lg: -0.02em,
  ),
  3: (
    font-size-sm: map-get($font-sizes, 3xl),        // 32px
    font-size-lg: map-get($font-sizes, 5xl),        // 40px
    line-height-sm: map-get($line-heights, 2xl),    // 120%
    line-height-lg: map-get($line-heights, 2xl),    // 120%
    font-weight-sm: map-get($font-weights, extra-bold),
    font-weight-lg: map-get($font-weights, extra-bold),
    letter-spacing-sm: 0,
    letter-spacing-lg: -0.01em,
  ),
  4: (
    font-size-sm: map-get($font-sizes, 2xl),        // 24px
    font-size-lg: map-get($font-sizes, 3xl),        // 32px
    line-height-sm: map-get($line-heights, lg),     // 140%
    line-height-lg: map-get($line-heights, xl),     // 130%
    font-weight-sm: map-get($font-weights, extra-bold),
    font-weight-lg: map-get($font-weights, extra-bold),
    letter-spacing-sm: 0,
    letter-spacing-lg: 0,
  ),
  5: (
    font-size-sm: map-get($font-sizes, xl),          // 20px
    font-size-lg: map-get($font-sizes, 2xl),        // 24px
    line-height-sm: map-get($line-heights, lg),     // 140%
    line-height-lg: map-get($line-heights, lg),     // 140%
    font-weight-sm: map-get($font-weights, bold),       // 700
    font-weight-lg: map-get($font-weights, extra-bold), // 800
    letter-spacing-sm: 0,
    letter-spacing-lg: 0,
  ),
  6: (
    font-size-sm: map-get($font-sizes, lg),          // 18px
    font-size-lg: map-get($font-sizes, xl),          // 20px
    line-height-sm: map-get($line-heights, lg),     // 140%
    line-height-lg: map-get($line-heights, lg),     // 140%
    font-weight-sm: map-get($font-weights, bold),   // 700
    font-weight-lg: map-get($font-weights, bold),   // 700
    letter-spacing-sm: 0,
    letter-spacing-lg: 0,
  ),
);

// ── Base styles ─────────────────────────────────────────────────────────────

.#{$component-class} {
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  margin: 0;
}

// ── Variant styles ──────────────────────────────────────────────────────────

@each $variant, $config in $heading-config {
  .#{$component-class}--#{$variant} {
    font-size: map-get($config, font-size-sm);
    line-height: map-get($config, line-height-sm);
    font-weight: map-get($config, font-weight-sm);
    letter-spacing: map-get($config, letter-spacing-sm);

    @include dh-md {
      font-size: map-get($config, font-size-lg);
      line-height: map-get($config, line-height-lg);
      font-weight: map-get($config, font-weight-lg);
      letter-spacing: map-get($config, letter-spacing-lg);
    }
  }
}

// ── Alignment (base) ────────────────────────────────────────────────────────

@each $align in $aligns {
  .#{$component-class}--align-#{$align} {
    text-align: $align;
  }
}

// ── Alignment (responsive) ──────────────────────────────────────────────────

@each $align in $aligns {
  .#{$component-class}--align-sm-#{$align} {
    @include dh-sm {
      text-align: $align;
    }
  }
}

@each $align in $aligns {
  .#{$component-class}--align-md-#{$align} {
    @include dh-md {
      text-align: $align;
    }
  }
}

@each $align in $aligns {
  .#{$component-class}--align-lg-#{$align} {
    @include dh-lg {
      text-align: $align;
    }
  }
}
